module.exports = __webpack_public_path__ + "ad.no2.f1eeec38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ad.no2.jpg
// module id = kQkx
// module chunks = 0